module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.de2bbf7d.jpg";